module.exports = __webpack_public_path__ + "img/438-3c6cdb.png";